import { render, staticRenderFns } from "./JobsearchListingDetail.vue?vue&type=template&id=9b9d3958&scoped=true&"
import script from "./JobsearchListingDetail.vue?vue&type=script&lang=ts&"
export * from "./JobsearchListingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./JobsearchListingDetail.vue?vue&type=style&index=0&id=9b9d3958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9d3958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VSimpleTable,VSpacer})
